import axios from './axios'
import defaultConfig from './config'
import Router from 'vue-router'
import { util as utils, storage } from "@common/utils/util.js"
import Constant from '@/Constant'

export default {
  context: {
    isloading: false,
  },

  // HTTP POST
  post: function({ fn, param, fullresult }, config, success, error) {
    let userAttrId = storage.session.get('userAttrId');
    let signKey = storage.local.get('signKey');
    let signFlag = storage.local.get('signFlag');
    fullresult = fullresult || (fullresult = true);
    config = Object.assign({}, utils.deepCopy(defaultConfig), config);

    if (!userAttrId || signFlag === null || (signFlag && !signKey)) {
      console.log('>>>>>>>>>>>>>>')
      return this.getSignKey().then(() => {
        return this.request('POST', { fn, param, fullresult }, config, success, error)
      }).catch(err => {
        console.error(err);
      });

    } else {
      return this.request('POST', { fn, param, fullresult }, config, success, error).catch(err => {
        console.error(err);
      });
    }
  },

  // HTTP GET
  get: function({ fn, param, fullresult }, config, success, error) {
    let userAttrId = storage.session.get('userAttrId');
    let signKey = storage.local.get('signKey');
    let signFlag = storage.local.get('signFlag');

    if (!userAttrId || signFlag === null || (signFlag && !signKey)) {
      return this.getSignKey().then(() => {
        return this.request('GET', { fn, param, fullresult }, config, success, error);
      }).catch(err => {
        console.error(err);
      });
    } else {
      return this.request('GET', { fn, param, fullresult }, config, success, error).catch(err => {
        console.error(err);
      });
    }
  },



  // HTTP REQUEST
  request: function(method, { fn, param, fullresult }, config, success, error) {
    method = method || 'post';

    // 参数校验
    if (!utils.checkParams({ fn, param, fullresult })) {
      return;
    };

    // 打包数据
    let data = {
      p0: fn,
      p1: JSON.stringify(param),
      userAttrId: storage.session.get('userAttrId'),
      fullresult: fullresult === true
    };

    // API签名
    let signFlag = storage.local.get('signFlag');
    if (signFlag) {
      data.sign = utils.doSign(data);
    }

    config.method = method;
    if (config.method.toLowerCase() == "get") {
      config.params = data;
    } else {
      config.data = data;
    }

    /*Indicator.open({
      //text: '努力加载中...',
      spinnerType: 'snake'
    });*/

    // 开发环境，打印调试URL
    if (Constant.env.ENV_MODE == 'development' && Constant.env.PRINT_DEBUG_URL) {
      let httpURL = utils.combHttpURL(config.baseURL, data);
      console.log('请求URL: ', httpURL);
    }

    // HTTP请求
    return axios.request(config).then(res => {
      /*Indicator.close();*/

      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return Promise.reject("请求服务异常！")
      }

      let result = (typeof res.data) == 'string' ? JSON.parse(res.data) : res.data;
      if (result.success === true) {
        success && success(result);
        storage.session.set('userAttrId', result.userAttrId);

        return Promise.resolve(res.data)
      } else {
        error && error(res.data);
        return Promise.reject(res.data)
      }
    }).catch(errors => {
      /*Indicator.close();*/

      error && error(errors.toString());
      return Promise.reject(errors.toString())
    })
  },

  // API sign key
  getSignKey: function() {
    const data = {
      p0: '',
      userAttrId: storage.session.get('userAttrId') || ""
    };

    let config = Object.assign({}, defaultConfig);
    config.baseURL = Constant.authBaseUrl;
    config.params = data;

    return axios.request(config).then(res => {
      console.log('get signKey:', res);
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return Promise.reject("请求服务异常！")
      }

      let result = (typeof res.data) == 'string' ? JSON.parse(res.data) : res.data;

      if (result.success === true) {
        let userAttrId = result.userAttrId;
        let signFlag = result.target && result.target.target && result.target.target.signFlag;
        let signKey = result.target && result.target.target && result.target.target.signKey;

        storage.local.set('signKey', signKey);
        storage.local.set('signFlag', signFlag);
        storage.session.set('userAttrId', userAttrId);

        if (signFlag && !signKey) {
          return this.logout().then(() => {
            return getSignKey();
          }).catch(err => {
            return Promise.reject(err)
          });
        }

        return Promise.resolve(result)
      } else {
        return Promise.reject(result)
      }
    }).catch(errors => {
      return Promise.reject(errors)
    })
  },

  // logout for new signKey
  logout: function() {
    const data = {
      p0: '',
      userAttrId: storage.session.get('userAttrId') || ""
    };

    let config = Object.assign({}, defaultConfig);
    config.baseURL = Constant.logoutBaseUrl;
    config.params = data;

    return axios.request(config).then(res => {
      console.log('get signKey:', res);
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return Promise.reject("请求服务异常！")
      }

      let result = (typeof res.data) == 'string' ? JSON.parse(res.data) : res.data;

      if (result.success === true) {
        return Promise.resolve(result)
      } else {
        return Promise.reject(result)
      }
    }).catch(errors => {
      return Promise.reject(errors)
    })
  }

}



// WEBPACK FOOTER //
// ./src/service/http.js